jQuery(function ($) {
  let isMobileInitialized = false;
  let $originalContainer;

  function getElements($mainSection) {
    return {
      $prependEl: $mainSection.find('.content-column-wrapper .ct-div-block'),
      $sliderRow: $mainSection.find('.cards-wrapper-row'),
      $moveItem: $mainSection.find('.bottom-featured-posts-row .hide-from-mobile')
    };
  }

  function shouldInitializeMobile() {
    return $(window).width() < 576 && !isMobileInitialized;
  }

  function shouldDestroyMobile() {
    return $(window).width() >= 576 && isMobileInitialized;
  }

  function moveToMobile($prependEl, $moveItem) {
    if ($prependEl.length && $moveItem.length) {
      $prependEl.prepend($moveItem);
    }
  }

  function restoreToOriginal($mainSection) {
    const $currentMovedItem = $mainSection.find('.content-column-wrapper .ct-div-block .hide-from-mobile');
    if ($originalContainer && $currentMovedItem.length) {
      $originalContainer.prepend($currentMovedItem);
    }
  }

  function initSlider($sliderRow) {
    if ($sliderRow.length && !$sliderRow.hasClass('slick-initialized')) {
      $sliderRow.slick({
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        variableWidth: true,
        autoplay: false,
        pauseOnHover: true
      });
    }
  }

  function destroySlider($sliderRow) {
    if ($sliderRow.hasClass('slick-initialized')) {
      $sliderRow.slick('unslick');
    }
  }

  function initMobileFeaturedPosts() {
    // Only proceed if .awards-icons-cards exists
    if (!$('.award-icons-cards').length) return;

    const $mainSection = $('.slider-section-mobile');
    if (!$mainSection.length) return;

    const { $prependEl, $sliderRow, $moveItem } = getElements($mainSection);

    if (!$originalContainer && $moveItem.length) {
      $originalContainer = $moveItem.parent();
    }

    if (shouldInitializeMobile()) {
      moveToMobile($prependEl, $moveItem);
      initSlider($sliderRow);
      isMobileInitialized = true;
      return;
    }

    if (shouldDestroyMobile()) {
      destroySlider($sliderRow);
      restoreToOriginal($mainSection);
      isMobileInitialized = false;
    }
  }

  $(window).on('load resize', initMobileFeaturedPosts);
});
